module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24406/sass/messagesWidgetShell.sass"